module.exports = __webpack_public_path__ + "static/media/shopping.3a409337.jpg";